import { render, staticRenderFns } from "./DateAndTimeForm.vue?vue&type=template&id=1b8dc510&scoped=true&"
import script from "./DateAndTimeForm.vue?vue&type=script&lang=js&"
export * from "./DateAndTimeForm.vue?vue&type=script&lang=js&"
import style0 from "./DateAndTimeForm.vue?vue&type=style&index=0&id=1b8dc510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8dc510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
